<template>
    <div class="edit-customer-data-container">
        <div class="section">
            <TextInput idstub="ZW1haWw=" :label="$t('general.email')" v-model="editCustomer.email" :edited="emailEdited" :disabled="true"/>
            <div class="spacer"></div>
        </div>
        
        <h2 class="section-header" v-if="withBankData">Kontodaten</h2>
        <div class="section" v-if="withBankData">
            <TextInput idstub="ZWRpdEliYW4=" :label="$t('general.iban')" :required="requiredIban" v-model="editCustomer.iban" :edited="ibanEdited" :error="validator.editCustomer.iban.$error"></TextInput>
            <TextInput idstub="ZWRpdEJpYw==" :label="$t('general.bic')" :required="requiredBic" v-model="editCustomer.bic" :edited="bicEdited" :error="validator.editCustomer.bic.$error"></TextInput>

            <!--<TextInput idstub="ZWRpdEJhbmtOYW1l" :label="$t('general.bank')" v-model="editCustomer.bankName" :disabled="true"/>
            <div></div>-->

            <CheckboxInput idstub="c2VwYQ==" :value="sepaconfirmed" :required="requiredSepaconfirmed" :text="$t('general.allow-sepa-payments')" @click="changeSepaconfirmed" :error="validator.sepaconfirmed.$error"/>
        </div>
            
        <h2 class="section-header">Persönliche Daten {{ subtitle }}</h2>
        <div class="section">
            <DropdownInput idstub="c2FsdXRhdGlvbg==" :label="$t('general.salutation')" :edited="salutationEdited" :model-value="editCustomer.salutationId || -1" @update:model-value="event => editCustomer.salutationId = event.displayid" :option-list="baseData.salutations" :default-option="true"/>
            <DropdownInput idstub="dGl0bGU=" :label="$t('general.title')" :edited="titleEdited" :model-value="editCustomer.titleId || -1" @update:model-value="event => editCustomer.titleId = event.displayid" :option-list="baseData.titles" :default-option="true"/>

            <TextInput idstub="Zmlyc3RuYW1l" :label="$t('general.firstname')" :required="requiredFirstName" v-model="editCustomer.firstName" :edited="firstNameEdited" :error="validator.editCustomer.firstName.$error"/>
            <TextInput idstub="bGFzdG5hbWU=" :label="$t('general.lastname')" :required="requiredLastName" v-model="editCustomer.lastName" :edited="lastNameEdited" :error="validator.editCustomer.lastName.$error"/>

            <DateInput idstub="YmlydGhkYXRl" :label="$t('general.birthdate')" :required="requiredBirthdate" :clearable="!requiredBirthdate" v-model="editCustomer.birthdate" :edited="birthdateEdited"/>
            <TextInput idstub="cGhvbmU=" :label="$t('general.phone')" :required="requiredPhone" v-model="editCustomer.phone" :edited="phoneEdited"/>
        </div>

        <h2 class="section-header">Adresse {{ subtitle }}</h2>
        <div class="section">
            <TextInput idstub="c3RyZWV0" :label="$t('general.street')" :required="requiredStreet" v-model="editCustomer.street" :edited="streetEdited" :error="validator.editCustomer.street.$error"/>
            <TextInput idstub="aG91c2UtbnI=" :label="$t('general.house-nr')" :required="requiredHouseNr" v-model="editCustomer.houseNr" :edited="houseNrEdited" :error="validator.editCustomer.houseNr.$error"/>

            <TextInput idstub="bnItaW5mbw==" :label="$t('general.house-nr-info')" v-model="editCustomer.houseNrInfo" :edited="houseNrInfoEdited"/>
            <div class="spacer"></div>

            <TextInput idstub="emlw" :label="$t('general.zip')" :required="requiredZip" v-model="editCustomer.zip" :edited="zipEdited" :error="validator.editCustomer.zip.$error"/>
            <TextInput idstub="Y2l0eQ==" :label="$t('general.city')" :required="requiredCity" v-model="editCustomer.city" :edited="cityEdited" :error="validator.editCustomer.city.$error"/>

            <TextInput idstub="ZGlzdHJpY3Q=" :label="$t('general.district')" :required="requiredDistrict" v-model="editCustomer.district" :edited="districtEdited"/>
            <DropdownInput idstub="Y291bnRyeQ==" :label="$t('general.country')" :required="requiredCountry" :edited="countryEdited" idForSelection="original" :model-value="editCustomer.countryId || 'DE'" @update:model-value="event => editCustomer.country = event.original" :option-list="baseData.countries" :default-option="true"/>
        </div>

        <span class="required-footnote" v-show="requiredFootnote">{{ $t('general.required-field') }}</span>

        <div class="actions">
            <button id="c3VibWl0" class="button active" @click="handleSubmit">
                <label>{{ $t('general.submit-changes') }}</label>
            </button>
            <button id="cmVzZXQ=" class="button passive" @click="reset">
                <label>{{ $t('general.reset-changes') }}</label>
            </button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

import TextInput from '@elements/TextInput.vue'
import CheckboxInput from '@elements/CheckboxInput.vue'
import DateInput from '@elements/DateInput.vue'
import DropdownInput from '@elements/DropdownInput.vue'
import { useVuelidate } from '@vuelidate/core'
import { requiredIf, sameAs } from '@vuelidate/validators'

const EMIT_SUBMIT = 'submit'

export default {
    name: "edit-customer-data",
    emits: [ EMIT_SUBMIT ],
    inject: ['util', 'globalState', 'baseData','toast' ],
    props: {
        customer: {
            type: Object,
            required: true
        },
        withBankData: {
            type: Boolean,
            default: false
        },
        subtitle: {
            type: String,
            default: ''
        }
    },
    setup() {
        return {
            validator: useVuelidate()
        }
    },
    data() {
        return {
            editCustomer: {
                // listed only required fields
                salutationId: '',
                titleId: '',
                firstName: '',
                lastName: '',
                phone: '',
                birthdate: '',
                street: '',
                houseNr: '',
                houseNrInfo: '',
                zip: '',
                city: '',
                district: '',
                countryId: '',

                iban: '',
                bic: '',
                //bankName: ''
            },
            sepaconfirmed: true,
            ibanChecked: true,
            showAreYouSure: false,

            //validations
            requiredSalutation: true,
            requiredTitle:      false,
            requiredFirstName:  true,
            requiredLastName:   true,
            requiredPhone:      false,
            requiredBirthdate:  true,

            requiredStreet:      true,
            requiredHouseNr:     true,
            requiredHouseNrInfo: false,
            requiredCity:        true,
            requiredZip:         true,
            requiredDistrict:    false,
            requiredCountry:     true,

            requiredIban: this.withBankData,
            //requiredBic: false,
            requiredSepaconfirmed: true,

            requiredFootnote: true
        }
    },
    computed: {
        requiredBic() {
            return this.withBankData && !this.editCustomer.iban.toLowerCase().startsWith('de')
        },
        emailEdited() {
            return this.editCustomer.email !== this.customer.email
        },
        salutationEdited() {
            return this.editCustomer.salutationId !== this.customer.salutationId
        },
        titleEdited() {
            return this.editCustomer.titleId !== this.customer.titleId
        },
        firstNameEdited() {
            return this.editCustomer.firstName !== this.customer.firstName
        },
        lastNameEdited() {
            return this.editCustomer.lastName !== this.customer.lastName
        },
        birthdateEdited() {
            const edited = new Date(this.editCustomer.birthdate)
            const loaded = new Date(this.customer.birthdate)

            const sameDay   = edited.getDate() === loaded.getDate()
            const sameMonth = edited.getMonth() === loaded.getMonth()
            const sameYear  = edited.getFullYear() === edited.getFullYear()

            return !sameDay || !sameMonth || !sameYear
        },
        phoneEdited() {
            return this.editCustomer.phone !== this.customer.phone
        },
        streetEdited() {
            return this.editCustomer.street !== this.customer.street
        },
        houseNrEdited() {
            return this.editCustomer.houseNr !== this.customer.houseNr
        },
        houseNrInfoEdited() {
            return this.editCustomer.houseNrInfo !== this.customer.houseNrInfo
        },
        zipEdited() {
            return this.editCustomer.zip !== this.customer.zip
        },
        cityEdited() {
            return this.editCustomer.city !== this.customer.city
        },
        districtEdited() {
            return this.editCustomer.district !== this.customer.district
        },
        countryEdited() {
            return this.editCustomer.countryId !== this.customer.countryId
        },
        ibanEdited() {
            return this.withBankData && this.editCustomer.iban !== this.customer.iban
        },
        bicEdited() {
            return this.withBankData && this.editCustomer.bic !== this.customer.bic
        },
        anyEdits() {
            return this.emailEdited 
                    || this.salutationEdited 
                    || this.titleEdited
                    || this.firstNameEdited
                    || this.lastNameEdited
                    || this.birthdateEdited
                    || this.phoneEdited
                    || this.streetEdited
                    || this.houseNrEdited
                    || this.houseNrInfoEdited
                    || this.zipEdited
                    || this.cityEdited
                    || this.districtEdited
                    || this.countryEdited
                    || this.ibanEdited
        }
    },
    validations() {
        return {
            editCustomer: {
                salutationId: { requiredIf: requiredIf(this.requiredSalutation), $autoDirty: this.requiredSalutation },
                titleId:      { requiredIf: requiredIf(this.requiredTitle), $autoDirty: this.requiredTitle },
                firstName:    { requiredIf: requiredIf(this.requiredFirstName), $autoDirty: this.requiredFirstName },
                lastName:     { requiredIf: requiredIf(this.requiredLastName), $autoDirty: this.requiredLastName },
                phone:        { requiredIf: requiredIf(this.requiredPhone), $autoDirty: this.requiredPhone },
                birthdate:    { requiredIf: requiredIf(this.requiredBirthdate), $autoDirty: this.requiredBirthdate },

                street:      { requiredIf: requiredIf(this.requiredStreet), $autoDirty: this.requiredStreet },
                houseNr:     { requiredIf: requiredIf(this.requiredHouseNr), $autoDirty: this.requiredHouseNr },
                houseNrInfo: { requiredIf: requiredIf(this.requiredHouseNrInfo), $autoDirty: this.requiredHouseNrInfo },
                zip:         { requiredIf: requiredIf(this.requiredZip), $autoDirty: this.requiredZip },
                city:        { requiredIf: requiredIf(this.requiredCity), $autoDirty: this.requiredCity },
                district:    { requiredIf: requiredIf(this.requiredDistrict), $autoDirty: this.requiredDistrict },
                countryId:   { requiredIf: requiredIf(this.requiredCountry), $autoDirty: this.requiredCountry },

                iban: { requiredIf: requiredIf(this.requiredIban), $autoDirty: this.requiredIban },
                bic: { requiredIf: requiredIf(this.requiredBic), $autoDirty: this.requiredBic },
            },
            sepaconfirmed: { sameAs: sameAs(this.requiredSepaconfirmed) , $autoDirty: this.requiredSepaconfirmed }
        }
    },
    methods: {
        changeSepaconfirmed() {
            if(this.ibanChecked) {
                this.sepaconfirmed = !this.sepaconfirmed
            } else {
                this.globalState.isLoading = true

                let checkibanurl = this.util.middleware()
                checkibanurl += '/checkiban/' + this.editCustomer.iban

                if (this.editCustomer.bic) {
                    checkibanurl += '?bic=' + this.editCustomer.bic
                }

                axios.get(checkibanurl)
                .then(response => {
                    this.globalState.isLoading = false
                    if (response.data.status.ErrorCode !== 0) {
                        this.ibanChecked = false
                        this.sepaconfirmed = false
                        const errorMessage = this.$t('bankdata.iban-error')
                        this.toast.error(errorMessage)
                        //TODO identisch mit kunde false
                    } else {
                        this.ibanChecked = true
                        this.sepaconfirmed = true
                    }
                })
                .catch(() => {
                    const errorMessage = this.$t('bankdata.iban-check-connection-error')
                    this.toast.error(errorMessage)
                    this.ibanChecked = false
                    this.sepaconfirmed = false
                })
            }
        },
        reset() {
            if (!this.anyEdits) {
                const warnMessage = this.$t('general.no-changes')
                this.toast.warn(warnMessage)
                return
            }
            Object.assign(this.editCustomer, this.customer)
        },
        handleSubmit() {
            // don't validate if unchanged
            if (!this.anyEdits) {
                const warnMessage = this.$t('general.no-changes')
                this.toast.warn(warnMessage)
                return
            }
            // validate
            this.validator.$validate()
            if (this.validator.$invalid) {
                return
            }
            this.validator.$reset()
            // is valid -> emit
            this.$emit(EMIT_SUBMIT, this.editCustomer)
        },
    },
    watch: {
        customer: {
            deep: true,
            handler(newValue) {
                if (newValue) {
                    this.reset()
                }
            }
        },
        'editCustomer.iban': {
            handler(newValue) {
                if(newValue && this.ibanEdited) {
                    this.sepaconfirmed = false
                    this.ibanChecked = false
                }
            }
        },
        'editCustomer.bic': {
            handler(newValue) {
                if(newValue && this.bicEdited) {
                    this.sepaconfirmed = false
                    this.ibanChecked = false
                }
            }
        }
    },
    components: {
        TextInput,
        CheckboxInput,
        DropdownInput,
        DateInput
    }
}
</script>

<style lang="scss" scoped>
@use '@css/mixins/required';
.edit-customer-data-container {
    width: 100%;
    @include required.footnote;
    > .section {
        padding: 0 16px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        > div {
            width: 49%;
        }

        @media(max-width: 575px) {
            > div {
                width: 100%;
            }
        }
    }

    > .actions {
        margin-top: 20px;
        padding: 0 16px;
        width: 100%;
        display: flex;
        justify-content: flex-end;

        @media(max-width: 575px) {
            flex-wrap: wrap;
        }

        > button {
            margin-left: 16px;
            padding-left: 16px;
            padding-right: 16px;

            @media(max-width: 575px) {
                width: 100%;
            }
        }

        > button:nth-of-type(2) {
            @media(max-width: 575px) {
                margin-top: 10px;
            }
        }
    }
}
</style>